module.exports = {
  "roster": [
    {
      "id": "ada-ironwright",
      "name": "Ada Ironwright",
      "title": "The Engineer",
      "stats": {
        "capital": 6,
        "luck": 4,
        "negotiation": 5,
        "charisma": 5,
        "tech": 8,
        "stamina": 6
      },
      "passive": {
        "id": "pioneer",
        "name": "Precision Works",
        "description": "Property upgrade cost -20%."
      },
      "color": "#2e7d32"
    },
    {
      "id": "silas-vance",
      "name": "Silas Vance",
      "title": "The Financier",
      "stats": {
        "capital": 8,
        "luck": 3,
        "negotiation": 7,
        "charisma": 5,
        "tech": 4,
        "stamina": 7
      },
      "passive": {
        "id": "financier",
        "name": "Hard Reserves",
        "description": "Property purchase price -10%. Financial negative-event losses -20%."
      },
      "color": "#c62828"
    }
  ],
  "lore": {
    "ada-ironwright": {
      "nameZh": "Ada Ironwright",
      "titleZh": "The Engineer",
      "identity": "The Engineer",
      "alignment": "Strategy",
      "background": "Ada Ironwright, The Engineer, contends for control of the board.",
      "joining": "On the board, Ada Ironwright plays to their strengths.",
      "styleIntro": "Ada Ironwright plays by one rule:",
      "style": [
        "Press every advantage."
      ],
      "styleOutro": "They adapt to the board as it turns.",
      "relationships": [
        {
          "target": "Silas Vance",
          "description": "A rival contesting the board."
        }
      ],
      "themeSummary": "Ada Ironwright\nplays to win."
    },
    "silas-vance": {
      "nameZh": "Silas Vance",
      "titleZh": "The Financier",
      "identity": "The Financier",
      "alignment": "Strategy",
      "background": "Silas Vance, The Financier, contends for control of the board.",
      "joining": "On the board, Silas Vance plays to their strengths.",
      "styleIntro": "Silas Vance plays by one rule:",
      "style": [
        "Press every advantage."
      ],
      "styleOutro": "They adapt to the board as it turns.",
      "relationships": [
        {
          "target": "Ada Ironwright",
          "description": "A rival contesting the board."
        }
      ],
      "themeSummary": "Silas Vance\nplays to win."
    }
  },
  "map": {
    "spaceCount": 12,
    "layout": {
      "type": "circle"
    },
    "spaces": [
      {
        "id": 0,
        "name": "GO",
        "type": "go"
      },
      {
        "id": 1,
        "name": "Foundry Row",
        "type": "property",
        "color": "red",
        "price": 60,
        "rent": 4
      },
      {
        "id": 2,
        "name": "Coal Yard",
        "type": "property",
        "color": "red",
        "price": 60,
        "rent": 4
      },
      {
        "id": 3,
        "name": "Chance",
        "type": "chance"
      },
      {
        "id": 4,
        "name": "Rail Exchange",
        "type": "property",
        "color": "blue",
        "price": 100,
        "rent": 6
      },
      {
        "id": 5,
        "name": "Excise Office",
        "type": "tax",
        "taxAmount": 100
      },
      {
        "id": 6,
        "name": "Jail",
        "type": "jail"
      },
      {
        "id": 7,
        "name": "Gasworks",
        "type": "property",
        "color": "blue",
        "price": 100,
        "rent": 6
      },
      {
        "id": 8,
        "name": "Community Chest",
        "type": "community"
      },
      {
        "id": 9,
        "name": "Grand Terminal",
        "type": "property",
        "color": "green",
        "price": 140,
        "rent": 10
      },
      {
        "id": 10,
        "name": "Steel Mill",
        "type": "property",
        "color": "green",
        "price": 140,
        "rent": 10
      },
      {
        "id": 11,
        "name": "Chance",
        "type": "chance"
      }
    ],
    "colorGroups": {
      "red": {
        "name": "Ironworks",
        "spaces": [
          1,
          2
        ]
      },
      "blue": {
        "name": "Rail",
        "spaces": [
          4,
          7
        ]
      },
      "green": {
        "name": "Civic",
        "spaces": [
          9,
          10
        ]
      }
    },
    "specialSpaces": {
      "go": 0,
      "jail": 6
    },
    "theme": {
      "boardBackground": "#1b1b2a",
      "cellBackground": "#2c2c3e"
    },
    "cards": {
      "chance": [
        {
          "text": "All aboard — advance to GO. Collect $200.",
          "action": "moveTo",
          "value": 0
        },
        {
          "text": "Patent royalties pay out. Collect $75.",
          "action": "gain",
          "value": 75
        },
        {
          "text": "Boiler inspection levy. Pay 10% of your assets.",
          "action": "payPercent",
          "value": 10
        },
        {
          "text": "Hauled before the magistrate. Go to Jail.",
          "action": "goToJail",
          "value": 0
        }
      ],
      "community": [
        {
          "text": "Dividend from the works. Collect $50.",
          "action": "gain",
          "value": 50
        },
        {
          "text": "Town subsidy — every baron collects $40.",
          "action": "gainAll",
          "value": 40
        },
        {
          "text": "Grand exhibition! Free upgrade on one property.",
          "action": "freeUpgrade",
          "value": 0
        },
        {
          "text": "Back taxes assessed. Pay 8% of your assets.",
          "action": "payPercent",
          "value": 8
        }
      ]
    },
    "id": "steam-barons",
    "name": "Steam Barons"
  }
}
;